const url = '/credit-payment-options';
const Provider = 'CreditPaymentOptions';
const dbModel = 'CreditPaymentOptions';

export { url, Provider, dbModel };
